"use strict";

define('view/decision.detail.summary',['require','exports','module','underscore','marionette','uikit/uikit','uikit/collections/form','uikit/collections/table','uikit/collections/list','uikit/elements/text','./html.viewer','libs/format/date','libs/format/empty','libs/format/list','config','templates'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var UIKit = require('uikit/uikit');
  var FormView = require('uikit/collections/form');
  var TableView = require('uikit/collections/table');
  var ListView = require('uikit/collections/list');
  var TextView = require('uikit/elements/text');
  var HTMLViewer = require('./html.viewer');
  var DateFormatter = require('libs/format/date');
  var EmptyFormatter = require('libs/format/empty');
  var ListFormatter = require('libs/format/list');
  var config = require('config');
  var Templates = require('templates');
  var linkTextFormatter = function linkTextFormatter(v) {
    return new Handlebars.SafeString('<span class="link">' + v + '</span>');
  };
  var DecisionDetailSummary = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    className: 'ui segment',
    template: Templates.IRB['decision.detail.summary'],
    options: {
      letters: null
    },
    update: {
      letters: false
    },
    internalViews: {
      findings: HTMLViewer,
      recused: HTMLViewer,
      researchersNotes: HTMLViewer,
      internalNotes: HTMLViewer,
      expirationJustification: HTMLViewer
    },
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this.setupDecisionFields();
    },
    onShow: function onShow() {
      if (this.recused) {
        this.recused.$el.prev('.ui.header').addClass('dividing');
      }
      this.findings.$el.prev('.ui.header').addClass('dividing');
      this.researchersNotes.$el.prev('.ui.header').addClass('dividing');
      this.internalNotes.$el.prev('.ui.header').addClass('dividing');
    },
    setupDecisionFields: function setupDecisionFields() {
      var form = this.decisionForm,
        formGroup = form.addGroup(),
        textEmptyFormatter = EmptyFormatter('--'),
        dateFormatter = DateFormatter(config.dateFormat, '--'),
        adminCheckinDateOptions = {
          name: 'adminCheckinDate',
          model: this.model,
          bindings: {
            text: 'adminCheckinDate'
          },
          formatter: dateFormatter
        },
        expirationDateOptions = {
          name: 'expirationDate',
          model: this.model,
          bindings: {
            text: 'expirationDate'
          },
          formatter: dateFormatter
        },
        motionedOptions = {
          model: this.model.get('motioned'),
          bindings: {
            text: 'displayName'
          },
          formatter: textEmptyFormatter
        },
        secondedOptions = {
          model: this.model.get('seconded'),
          bindings: {
            text: 'displayName'
          },
          formatter: textEmptyFormatter
        },
        voteForOptions = {
          model: this.model,
          bindings: {
            text: 'voteFor'
          },
          formatter: textEmptyFormatter
        },
        voteAgainstOptions = {
          model: this.model,
          bindings: {
            text: 'voteAgainst'
          },
          formatter: textEmptyFormatter
        },
        voteAbstainOptions = {
          model: this.model,
          bindings: {
            text: 'voteAbstain'
          },
          formatter: textEmptyFormatter
        };
      if (this.model.get('finalizedDate')) {
        this.decisionStatus.text = 'Completed';
        this.decisionStatus.color = 'green';
      } else {
        this.decisionStatus.text = 'Pending';
        this.decisionStatus.color = 'yellow';
      }
      this.decisionStatus.detail = this.model.get('responsiblePerson').get('displayName');
      if (this.isFullBoardReview()) {
        formGroup.addField({
          text: 'Motioned'
        }, new TextView(motionedOptions)).getOption('parent').addField({
          text: 'Seconded'
        }, new TextView(secondedOptions)).getOption('parent').addField({
          text: 'Votes For'
        }, new TextView(voteForOptions)).getOption('parent').addField({
          text: 'Votes Against'
        }, new TextView(voteAgainstOptions)).getOption('parent').addField({
          text: 'Votes Abstained'
        }, new TextView(voteAbstainOptions));
        this.recused.fluid = true;
        this.recused.model = this.model;
        this.recused.bindings = {
          text: 'recused'
        };
      }
      if (this.model.decisionSupportsAdminCheckinDate()) {
        formGroup.addField({
          text: 'Administrative Check-in Date'
        }, new TextView(adminCheckinDateOptions));
      }
      if (this.model.isExpirationDateVisible()) {
        formGroup.addField({
          text: 'Expiration Date'
        }, new TextView(expirationDateOptions));
      }
      if (this.expirationJustification) {
        this.expirationJustification.fluid = true;
        this.expirationJustification.model = this.model;
        this.expirationJustification.bindings = {
          text: 'expirationJustification'
        };
      }
      if (this.categoriesForm) {
        this.categoriesForm.addField({}, new HTMLViewer.List({
          name: 'categories',
          collection: this.model.get('categories'),
          childViewOptions: {
            bindings: {
              text: 'labeledDescription'
            }
          }
        }));
      }
      this.findings.fluid = true;
      this.findings.model = this.model;
      this.findings.bindings = {
        text: 'findings'
      };
      this.researchersNotes.fluid = true;
      this.researchersNotes.model = this.model;
      this.researchersNotes.bindings = {
        text: 'researchNotes'
      };
      this.internalNotes.fluid = true;
      this.internalNotes.model = this.model;
      this.internalNotes.bindings = {
        text: 'internalNotes'
      };
      if (this.lettersTable) {
        var LETTERS_COLUMNS = [{
          text: 'Subject',
          data: 'subject',
          formatter: linkTextFormatter
        }, {
          text: 'Recipients',
          data: 'recipients',
          formatter: ListFormatter()
        }, {
          text: 'Sent Date',
          data: 'dateSent',
          formatter: DateFormatter(config.dateFormat)
        }];
        this.lettersTable.collection = this.getOption('letters');
        this.lettersTable.link = true;
        this.lettersTable.sortable = false;
        this.lettersTable.selectable = true;
        this.lettersTable.compact = true;
        this.lettersTable.columns.add(LETTERS_COLUMNS);
        this.listenTo(this.lettersTable, 'row:press', function (row) {
          var popup = app.request('pdf:popup');
          var submissionService = app.service('submission');
          submissionService.createLetterPDF(row.model.get('contentSent'), popup);
        });
      }
    },
    isFullBoardReview: function isFullBoardReview() {
      var model = this.model;
      if (model.get('motioned') || model.get('seconded') || model.get('voteFor') || model.get('voteAgainst') || model.get('voteAbstain') || model.get('recused')) {
        return true;
      }
      return String(model.get('type')).toLowerCase() == 'full';
    },
    useExpirationJustification: function useExpirationJustification() {
      return (this.isExpeditedPost2018Rule() || this.isAdminPost2018Rule()) && this.model.get('continuingReviewRequired');
    },
    isExpeditedPost2018Rule: function isExpeditedPost2018Rule() {
      var model = this.model;
      return model.get('type') === config.EXPEDITED_REVIEW_TYPE && model.get('policyName') === config.POST_2018_POLICY;
    },
    isAdminPost2018Rule: function isAdminPost2018Rule() {
      var model = this.model;
      return model.get('type') === config.ADMIN_REVIEW_TYPE && model.get('policyName') === config.POST_2018_POLICY;
    },
    isLimitedIrb: function isLimitedIrb() {
      return this.model.get('type') === config.LIMITED_REVIEW_TYPE;
    },
    isExempt: function isExempt() {
      return this.model.get('type') === config.EXEMPT_REVIEW_TYPE;
    },
    isRecusedAvailable: function isRecusedAvailable() {
      return this.isFullBoardReview();
    },
    serializeData: function serializeData() {
      var data = UIKit.ComponentMixin.serializeData.apply(this, arguments);
      data.decisionTypeDescription = this.model.get('decisionType.description');
      data.decisionResultDate = DateFormatter(config.dateFormat)(this.model.get('resultDate'));
      data.useExpirationJustification = this.useExpirationJustification();
      data.isRecusedAvailable = this.isRecusedAvailable();
      return data;
    }
  });
  module.exports = DecisionDetailSummary;
});

